import { Epic, ofType } from 'redux-observable';
import { of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { EpicDependencies } from '@ui/store/rootEpic';
import { setUserToken, getUserToken } from '@ui/tools/token';
import * as actions from '../actions';
import { metaRequested } from '@ui/store/meta/actions';

export const loginEpic: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { authApi },
) =>
  action$.pipe(
    ofType(actions.AUTH_ACTIONS.LOGIN_REQUESTED),
    switchMap((action: actions.LoginRequested) =>
      authApi.login(action.payload).pipe(
        switchMap(({ user, token }) => {
          setUserToken(token);
          return of(metaRequested(), actions.loginSucceeded(user));
        }),
        catchError(({ response: { error } }) => of(actions.loginFailed(error))),
      ),
    ),
  );

export const logoutEpic: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { authApi },
) =>
  action$.pipe(
    ofType(actions.AUTH_ACTIONS.LOGOUT_REQUESTED),
    switchMap(() => {
      const token = getUserToken();
      return authApi.logout(token).pipe(
        map(() => actions.logoutSucceeded()),
        catchError(({ response: { error } }) => of({})),
      );
    }),
  );



// WEBPACK FOOTER //
// ./src/store/auth/epics/login.ts